import getConf from '../../config/env'

function Config() {}

Config.install = function (Vue, params) {
  const config = getConf(params)
  // console.log('当前配置：', config)
  Vue.prototype.$config = config
}

export default Config